"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFetchArgs = exports.addFetchInstrumentationHandler = void 0;
var utils_1 = require("../utils");
var object_1 = require("../utils/object");
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler) {
    if (!('fetch' in utils_1.GLOBAL_OBJ)) {
        return;
    }
    (0, object_1.fill)(utils_1.GLOBAL_OBJ, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a = parseFetchArgs(args), method = _a.method, url = _a.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url,
                },
                startTimestamp: Date.now(),
            };
            handler(__assign({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(utils_1.GLOBAL_OBJ, args).then(function (response) {
                var finishedHandlerData = __assign(__assign({}, handlerData), { endTimestamp: Date.now(), response: response });
                handler(finishedHandlerData);
                return response;
            }, function (error) {
                var erroredHandlerData = __assign(__assign({}, handlerData), { endTimestamp: Date.now(), error: error });
                handler(erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
exports.addFetchInstrumentationHandler = addFetchInstrumentationHandler;
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) {
        return { method: 'GET', url: '' };
    }
    if (fetchArgs.length === 2) {
        var _a = fetchArgs, url = _a[0], options = _a[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, 'method')
                ? String(options.method).toUpperCase()
                : 'GET',
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
    };
}
exports.parseFetchArgs = parseFetchArgs;
function hasProp(obj, prop) {
    return (!!obj && typeof obj === 'object' && !!obj[prop]);
}
function getUrlFromResource(resource) {
    if (typeof resource === 'string') {
        return resource;
    }
    if (!resource) {
        return '';
    }
    if (hasProp(resource, 'url')) {
        return resource.url;
    }
    if (resource.toString) {
        return resource.toString();
    }
    return '';
}
